import { render, staticRenderFns } from "./MotherAndBabyInfo.vue?vue&type=template&id=2c1b3366&scoped=true"
import script from "./MotherAndBabyInfo.vue?vue&type=script&lang=js"
export * from "./MotherAndBabyInfo.vue?vue&type=script&lang=js"
import style0 from "./MotherAndBabyInfo.vue?vue&type=style&index=0&id=2c1b3366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1b3366",
  null
  
)

export default component.exports